const LIGHT_SYMBOL_COUNT = 4;

export const splitAddressWithEllipsis = (address: string, maxAddressLength: number): [string, string, string] => {
  if (!address) return ['', '', ''];
  const ell = '...';
  const minLength = LIGHT_SYMBOL_COUNT * 2;

  if (address.length <= minLength) {
    return ['', address, ''];
  }

  const start = address.slice(0, LIGHT_SYMBOL_COUNT);
  let center = address.slice(LIGHT_SYMBOL_COUNT, -LIGHT_SYMBOL_COUNT);
  const end = address.slice(-LIGHT_SYMBOL_COUNT);

  if (address.length <= maxAddressLength) {
    return [start, center, end];
  }

  const x = (maxAddressLength - 2 * LIGHT_SYMBOL_COUNT - ell.length) / 2;
  const keepLeft = Math.ceil(x);
  const keepRight = Math.floor(x);

  center = center.slice(0, keepLeft) + ell + center.slice(center.length - keepRight);

  return [start, center, end];
};
